export function escapeHtml(unsafe: string): string {
  return unsafe
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

// Like escapeHtml but emits the canonical XML `&apos;` for apostrophes; use for
// XML/SVG/KML element text and attribute values.
export function escapeXml(unsafe: string): string {
  return unsafe
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&apos;');
}

export function removeAccents(value: string) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function objectToURLSearchParams(query: Record<string, unknown>) {
  const res: [string, string][] = [];

  for (const [k, v] of Object.entries(query)) {
    if (Array.isArray(v)) {
      for (const item of v) {
        if (item !== undefined) {
          res.push([k, item === null ? '' : String(item)]);
        }
      }
    } else if (v !== undefined) {
      res.push([k, v === null ? '' : String(v)]);
    }
  }

  return new URLSearchParams(res);
}

/**
 * Orders by a label the way the current language reads it, putting anything
 * unnamed last rather than wherever its placeholder happens to collate.
 */
export function makeLabelComparator(language: string) {
  const collator = new Intl.Collator(language, { sensitivity: 'base' });

  return (a: string | undefined, b: string | undefined) =>
    a && b ? collator.compare(a, b) : a ? -1 : b ? 1 : 0;
}
